"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var conditional_permission_1 = require("./model/conditional-permission");
var material_1 = require("@angular/material");
var permission_manager_dialog_component_1 = require("./permission-manager-dialog/permission-manager-dialog.component");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var category_permission_manager_service_1 = require("./category-permission-manager.service");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var static_method_1 = require("../../../shared/utils/static-method");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var confirm_deletion_dialog_component_1 = require("./confirm-deletion-dialog/confirm-deletion-dialog.component");
var CategoryPermissionManagerComponent = /** @class */ (function () {
    function CategoryPermissionManagerComponent(currentLanguageProvider, kbService, cdRef, categoryPermissionManagerService, dialog) {
        this.currentLanguageProvider = currentLanguageProvider;
        this.kbService = kbService;
        this.cdRef = cdRef;
        this.categoryPermissionManagerService = categoryPermissionManagerService;
        this.dialog = dialog;
        // Public
        this.initialStateConditionalPermissions = [];
        this.filteredConditionalPermissions = [];
        this.metaCategories = [];
        this.pagingOptions = new idm_de_core_frontend_1.PagingOptions(0, 10);
        // Private
        this._destroy$ = new Subject_1.Subject();
    }
    CategoryPermissionManagerComponent.prototype.ngOnInit = function () {
        this.getCurrentLanguage();
        this.getMetaCategories();
        this.loadConditionalPermissions();
    };
    CategoryPermissionManagerComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    CategoryPermissionManagerComponent.prototype.ngAfterViewInit = function () {
        this.isPermissionsListInitialized = true;
        this.cdRef.detectChanges();
    };
    CategoryPermissionManagerComponent.prototype.editConditionalPermission = function (permission, i) {
        this.addOrUpdateConditionPermission(permission, i);
    };
    CategoryPermissionManagerComponent.prototype.addConditionalPermission = function () {
        var obj = {};
        obj[this.currentLanguageId] = '';
        this.addOrUpdateConditionPermission(new conditional_permission_1.ConditionalPermissionModel(null, '', static_method_1.convertObjectToMultilingualString(obj), '', '', 2));
    };
    CategoryPermissionManagerComponent.prototype.selectCategory = function (category) {
        this.categoryFilterValue = category;
        this.pagingOptions.offset = 0;
        this.filterConditionalPermissions();
    };
    CategoryPermissionManagerComponent.prototype.handleDescriptionFilterChange = function () {
        this.pagingOptions.offset = 0;
        this.filterConditionalPermissions();
    };
    CategoryPermissionManagerComponent.prototype.clearDescriptionFilter = function () {
        this.searchIsOpen = !this.searchIsOpen;
        this.textFilterValue = '';
        this.pagingOptions.offset = 0;
        this.filterConditionalPermissions();
    };
    CategoryPermissionManagerComponent.prototype.changePaging = function (page) {
        this.pagingOptions.offset = page;
        this.filterConditionalPermissions();
    };
    CategoryPermissionManagerComponent.prototype.removePermission = function (permission, index) {
        var _this = this;
        this.categoryPermissionManagerService.checkPermissionIsDeletable()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (deletable) {
            _this.openRemoveDialog(permission, index, deletable);
        });
    };
    CategoryPermissionManagerComponent.prototype.openRemoveDialog = function (permission, index, deletable) {
        var _this = this;
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '500px';
        dialogConfig.data = {
            isDeletable: deletable
        };
        this.dialog.open(confirm_deletion_dialog_component_1.ConfirmDeletionDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (confirm) {
            if (confirm) {
                _this.confirmDeletePermission(permission, index);
            }
        });
    };
    CategoryPermissionManagerComponent.prototype.confirmDeletePermission = function (permission, index) {
        var _this = this;
        this.categoryPermissionManagerService.removePermission(permission)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.initialStateConditionalPermissions = _this.initialStateConditionalPermissions.filter(function (perm) { return perm.permissionKey !== permission.permissionKey; });
            _this.filterConditionalPermissions();
        });
    };
    CategoryPermissionManagerComponent.prototype.filterConditionalPermissions = function () {
        var _this = this;
        this.filteredConditionalPermissions = this.getFilteredData().sort(function (a, b) {
            if (a.name.getValue(_this.currentLanguageId) < b.name.getValue(_this.currentLanguageId)) {
                return -1;
            }
            else if (a.name.getValue(_this.currentLanguageId) > b.name.getValue(_this.currentLanguageId)) {
                return 1;
            }
            return 0;
        }).splice(this.pagingOptions.offset * this.pagingOptions.limit, this.pagingOptions.limit);
    };
    CategoryPermissionManagerComponent.prototype.getFilteredData = function () {
        var _this = this;
        return this.initialStateConditionalPermissions.filter(function (perm) {
            if (_this.textFilterValue && _this.categoryFilterValue) {
                return perm.categorySystemName === _this.categoryFilterValue
                    && ((perm.description || '').toLowerCase().indexOf(_this.textFilterValue.toLowerCase()) > -1
                        || (perm.name.getValue(_this.currentLanguageId) || '').toLowerCase().indexOf(_this.textFilterValue.toLowerCase()) > -1);
            }
            else if (_this.textFilterValue) {
                return ((perm.description || '').toLowerCase().indexOf(_this.textFilterValue.toLowerCase()) > -1
                    || (perm.name.getValue(_this.currentLanguageId) || '').toLowerCase().indexOf(_this.textFilterValue.toLowerCase()) > -1);
            }
            else if (_this.categoryFilterValue) {
                return perm.categorySystemName === _this.categoryFilterValue;
            }
            return true;
        });
    };
    CategoryPermissionManagerComponent.prototype.getMetaCategories = function () {
        var _this = this;
        this.kbService.getMainEntityMetaCategories()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.metaCategories = Array.from(res);
        });
    };
    CategoryPermissionManagerComponent.prototype.addOrUpdateConditionPermission = function (permission, index) {
        var _this = this;
        if (index === void 0) { index = null; }
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '600px';
        dialogConfig.data = {
            permission: permission
        };
        this.dialog.open(permission_manager_dialog_component_1.PermissionManagerDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (condPerm) {
            if (condPerm) {
                if (index !== null) {
                    _this.filteredConditionalPermissions[index] = condPerm;
                }
                else {
                    _this.filteredConditionalPermissions.unshift(condPerm);
                }
            }
        });
    };
    CategoryPermissionManagerComponent.prototype.loadConditionalPermissions = function () {
        var _this = this;
        this.categoryPermissionManagerService.getConditionalPermissions()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.initialStateConditionalPermissions = res;
            _this.filteredConditionalPermissions = res;
            _this.filterConditionalPermissions();
        });
    };
    CategoryPermissionManagerComponent.prototype.getCurrentLanguage = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.currentLanguageId = res.getId();
        });
    };
    Object.defineProperty(CategoryPermissionManagerComponent.prototype, "length", {
        get: function () {
            return this.getFilteredData().length;
        },
        enumerable: true,
        configurable: true
    });
    CategoryPermissionManagerComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-category-permission-manager',
            styles: [require('./category-permission-manager.component.css')],
            template: require('./category-permission-manager.component.html')
        }),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_kb_service_client_js_1.KbService,
            core_1.ChangeDetectorRef,
            category_permission_manager_service_1.CategoryPermissionManagerService,
            material_1.MatDialog])
    ], CategoryPermissionManagerComponent);
    return CategoryPermissionManagerComponent;
}());
exports.CategoryPermissionManagerComponent = CategoryPermissionManagerComponent;
//# sourceMappingURL=category-permission-manager.component.js.map